import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import AppLayout from './app-layout'
import Loading from 'components/shared-components/Loading'
import { RefreshProvider } from './RefreshContext'
import EmployerAgreementGate from 'components/employer-agreement/EmployerAgreementGate'

const AppLayoutOutlet = () => (
  <RefreshProvider>
    <AppLayout>
      <EmployerAgreementGate>
        <Suspense fallback={<Loading cover="content" />}>
          <Outlet />
        </Suspense>
      </EmployerAgreementGate>
    </AppLayout>
  </RefreshProvider>
)

export default AppLayoutOutlet
